interface IFolder {
  id: number;
  author_name: string;
  can_delete: boolean;
  name: string;
  created_at: string;
  parent_description: string;
  student_description: string;
  teacher_description: string;
  type: string;
}

export interface IFolderIndex {
  categories: IFolder[];
  meta: {
    page: number;
    per_page: number;
    total: number;
    total_pages: number;
  }
}

export const categoryAdapter = (category: IFolder) => {
  return category;
};

export const subcategoryAdapter = (subcategory: IFolder) => {
  return subcategory;
};

export const resourceAdapter = (resource: any) => {
  return resource;
};

export const getCategoriesAdapter = (data: IFolderIndex) => {
  return data;
};

export const getSubcategoriesAdapter = (data: IFolderIndex) => {
  return data;
};

export const getResourcesAdapter = (data: any) => {
  /*
  previously mocked:
  {
    id: 'number',
    url: 'https://kinedu.com',
    resource_type: 'pdf',
    author: 'Cesar Hernandez',
    thumbnail: 'http://www.finsmes.com/wp-content/uploads/2018/09/kinedu-300x240.jpeg',
    title: 'Diverse Learning Styles in Early Childhood Educational days per babies',
    description: '',
    created_date: '01-12-12',
    can_delete: true,
  }
  */
  return data;
};
